import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { SalePopup } from "./components/SalePopup";
import { ComingSoonBanner } from "./components/ComingSoonBanner";
import { WhatsNewPopup } from "./components/WhatsNewPopup";
import { ReferralEventBanner } from "./components/ReferralEventBanner";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ProductDetailPage } from "./pages/ProductDetailPage";
import { CartPage } from "./pages/CartPage";
import { AdminPage } from "./pages/AdminPage";
import AccountPage from "./pages/AccountPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import PeptidesPage from "./pages/PeptidesPage";
import MaintenancePage from "./pages/MaintenancePage";
import { Toaster } from "./components/ui/sonner";

const MaintenanceGate = ({ children }) => {
  const [cfg, setCfg] = useState(null);
  const location = useLocation();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/maintenance`)
      .then(res => setCfg(res.data))
      .catch(() => setCfg({ enabled: false }));
  }, []);

  if (cfg === null) return <div className="min-h-screen bg-[#050505]" />;
  if (cfg.enabled && location.pathname !== "/admin") return <MaintenancePage message={cfg.message} />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <MaintenanceGate>
            <Navbar />
            <ComingSoonBanner />
            <WhatsNewPopup />
            <SalePopup />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/peptides" element={<PeptidesPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/product/:id" element={<ProductDetailPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </main>
            <Footer />
          </MaintenanceGate>
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
